


















































import {Component, Vue} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from '@/shared/services/mixin';
import {LadingCareStore} from "@/modules/ladingcare/store";
import {LadingCareParams} from "@/modules/ladingcare/params";
import LadingErrorStatusLabel from "@/shared/components/LadingErrorStatusLabel/index.vue";
import LadingCareTableAction from "@/modules/ladingcare/List/components/TableAction.vue";
import LadingCareSearch from "@/modules/ladingcare/List/components/Search.vue";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import LadingCareCreate from "@/modules/ladingcare/List/components/Create.vue";
import {LadingTargetType} from "@/enums/type/ladingtarget";
import EmployeeLabel from "@/modules/employees/List/components/Label.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {LadingCareStatus} from "@/enums/status/ladingcare";
import {LadingStatus} from "@/enums/status";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

@Component({
    name: "LadingCare",
    components: {
        TooltipLabel,
        EmployeeLabel,
        LadingCareCreate,
        LadingStatusLabel,
        LadingCareSearch,
        LadingCareTableAction,
        LadingErrorStatusLabel
    }
})
export default class extends mixins(CommonMixin) {
    LadingTargetType = LadingTargetType;
    LadingStatus = LadingStatus;
    LadingCareStatus = LadingCareStatus;
    columns = [
        {
            title: "Xử lý",
            dataIndex: "id",
            key: "action",
            scopedSlots: {customRender: "action"},
            width: 80,
            align: "center"
        },
        {
            title: "Ngày, giờ tạo yêu cầu",
            dataIndex: "createdDate",
            key: "ladingCode",
            width: 150,
            ellipsis: true
        },
        {
            title: "Mã vận đơn",
            dataIndex: "billLading.ladingCode",
            width: 120,
            ellipsis: true
        },
        {
            title: "Nội dung chi tiết yêu cầu",
            dataIndex: "note",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "note"}
        },
        {
            title: "Tuyến phát",
            dataIndex: "billLading.holdEmployee",
            width: 250,
            scopedSlots: {customRender: "holdEmployee"},
            ellipsis: true
        },
        {
            title: "Nhân viên tạo yêu cầu",
            dataIndex: "createdBy.employee.fullname",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "createdName"}
        },
        {
            title: "Trạng thái xử lý",
            dataIndex: "status",
            scopedSlots: {customRender: "status"},
            width: 120,
            ellipsis: true
        }
    ];
    
    
    get ladingCareList() {
        return LadingCareStore.ids.map((id: number) => LadingCareStore.data[id])
    }
    
    get pagination() {
        return {
            current: LadingCareStore.meta.page,
            pageSize: LadingCareStore.meta.limit,
            total: LadingCareStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} đơn yêu cầu`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }
    
    
    onChangePage(pagination: any) {
        LadingCareStore.listLadingCare({
            ...LadingCareStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        });
    }
    
    created() {
        LadingCareStore.listLadingCare({...new LadingCareParams()})
    }
}
